import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import PrometnaLogo from "../Slike/prometnaLogo.png";

import { ReactComponent as AddUserIkona } from "../Slike/addUserIkona.svg";
import { ReactComponent as CreateIncIkona } from "../Slike/createIncIkona.svg";
import { ReactComponent as DashboardIkona } from "../Slike/dashboardIkona.svg";
import { ReactComponent as AccountIkona } from "../Slike/accountIkona.svg";
import { ReactComponent as IncidentIkona } from "../Slike/incidentIkona.svg";
import { ReactComponent as LogoutIkona } from "../Slike/logoutIkona.svg";
import { ReactComponent as UsersIkona } from "../Slike/usersIkona.svg";

const Sidebar = ({ mobile, setMenuOpen }) => {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  let menuItems = [];

  // ================= ADMIN =================
  if (user?.role_id === 3) {
    menuItems = [
      {
        name: "Dashboard",
        path: "/",
        icon: <DashboardIkona className="w-5 h-5" />,
      },
      {
        name: "Tickets",
        path: "/tickets",
        icon: <IncidentIkona className="w-5 h-5" />,
      },
      {
        name: "Create Ticket",
        path: "/CreateTicket",
        icon: <CreateIncIkona className="w-5 h-5" />,
      },
      {
        name: "Users",
        path: "/users",
        icon: <UsersIkona className="w-5 h-5" />,
      },
      {
        name: "Add User",
        path: "/AddUser",
        icon: <AddUserIkona className="w-5 h-5" />,
      },
    ];
  }

  // ================= IKT =================
  if (user?.role_id === 2) {
    menuItems = [
      {
        name: "Tickets",
        path: "/tickets",
        icon: <IncidentIkona className="w-5 h-5" />,
      },
      {
        name: "Create Ticket",
        path: "/CreateTicket",
        icon: <CreateIncIkona className="w-5 h-5" />,
      },
      {
        name: "Users",
        path: "/users",
        icon: <UsersIkona className="w-5 h-5" />,
      },
    ];
  }

  // ================= USER =================
  if (user?.role_id === 1) {
    menuItems = [
      {
        name: "Create Ticket",
        path: "/CreateTicket",
        icon: <CreateIncIkona className="w-5 h-5" />,
      },
      {
        name: "Users",
        path: "/users",
        icon: <UsersIkona className="w-5 h-5" />,
      },
    ];
  }

  const bottomItems = [
    {
      name: "Profil",
      path: `/profile/${user?.id}`,
      icon: <AccountIkona className="w-5 h-5" />,
    },
    {
      name: "Odjavi se",
      path: "/login",
      icon: <LogoutIkona className="w-5 h-5" />,
    },
  ];

  return (
    <div className="w-64 bg-white p-2 h-full pb-6">
      <div className="bg-gray-50 rounded-2xl border border-gray-200 h-full flex flex-col justify-between">
        {/* TOP */}
        <div>
          <img src={PrometnaLogo} alt="Logo" className="w-full mb-4" />
          <h2 className="font-bold text-lg px-7 mb-4">Menu</h2>

          <ul>
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path;

              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-6 py-4 px-7 font-bold
                      ${
                        isActive
                          ? "text-midBlue border-l-8 border-midBlue"
                          : "text-lightAccent"
                      }`}
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* BOTTOM */}
        <div className="mb-4">
          {bottomItems.map((item) => {
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-6 py-4 px-7 font-bold
          ${
            isActive
              ? "text-midBlue border-l-8 border-midBlue"
              : "text-lightAccent"
          }`}
              >
                {item.icon}
                <span>{item.name}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
